import { render } from "./DemoDetails.vue?vue&type=template&id=1e3c2f08"
import script from "./DemoDetails.vue?vue&type=script&lang=js"
export * from "./DemoDetails.vue?vue&type=script&lang=js"

import "./DemoDetails.vue?vue&type=style&index=0&id=1e3c2f08&lang=css"

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__